import { validateIdNumber } from '@om/validation/src/validators/nam-id-validator';
import {
    SET_CELLPHONE_NUMBER_VALUE,
    SET_CREDIT_CHECK_CONSENT_VALUE,
    SET_EMPLOYER_NAME_VALUE,
    SET_EMPLOYMENT_STATUS_VALUE,
    SET_FIRST_NAME_VALUE,
    SET_ID_NUMBER_VALUE,
    SET_PAYSLIP_VALUE,
    SET_PRODUCT_VALUE,
    SET_SURNAME_VALUE,
    SET_TOWN_VALUE,
    SET_WAGE_FREQUENCY_VALUE,
    setCellphoneNumberValid,
    setCreditCheckConsentValid,
    setEmployerNameValid,
    setEmploymentStatusValid,
    setFirstNameValid,
    setIdNumberValid,
    setPayslipValid,
    setProductValid,
    setSurnameValid,
    setTownValid,
    setWageFrequencyValid,
} from '../../../actions/publicWeb/naPersonalLoansCallMeBack';
import {
    validateContactNumber,
    validateSingleSelection,
    validateName,
    validateAlphaNumericString,
} from '@om/validation';
import { validationIsEqual } from '../status';
import { getProductValue } from '../../../selectors/publicWeb/naPersonalLoansCallMeBack';

let prevValidationAction = null;
const gatsbyStack = process.env.GATSBY_COUNTRY_SELECTOR;

export const naPersonalLoansCallMeBackValidation = (store, next, action) => {
    const validationAction = (() => {
        let error;
        switch (action.type) {
            case SET_FIRST_NAME_VALUE:
                error = validateName(action.value, { min: 2, subject: 'First Name', max: 51 });
                return setFirstNameValid(error);
            case SET_SURNAME_VALUE:
                error = validateName(action.value, { min: 2, subject: 'Surname', max: 51 });
                return setSurnameValid(error);
            case SET_ID_NUMBER_VALUE:
                error = validateIdNumber(action.value, { checkAge: true, minAge: 21, maxAge: 60 });
                return setIdNumberValid(error);
            case SET_CELLPHONE_NUMBER_VALUE:
                error = validateContactNumber(action.value, {
                    subject: 'Cellphone Number',
                    countryCode: gatsbyStack,
                });
                return setCellphoneNumberValid(error);
            case SET_TOWN_VALUE:
                error = action.value
                    ? null
                    : "You'll need to select the town where you live or the nearest town to your location";
                return setTownValid(error);
            case SET_EMPLOYMENT_STATUS_VALUE:
                error =
                    action.value == 'other'
                        ? `Sorry, you have to be permanently employed for at least 3 months or contracted for at least 3 months`
                        : null;
                return setEmploymentStatusValid(error);
            case SET_WAGE_FREQUENCY_VALUE:
                error =
                    action.value == 'other'
                        ? 'Sorry, customers must receive their pay monthly to qualify for a loan.'
                        : null;
                return setWageFrequencyValid(error);
            case SET_PAYSLIP_VALUE:
                error =
                    action.value === 'no'
                        ? 'Sorry, we can only offer loans to applicants who provide us with a payslip.'
                        : null;
                return setPayslipValid(error);
            case SET_EMPLOYER_NAME_VALUE:
                const isTooShort = action.value.length < 2;
                const isTooLong = action.value.length > 100;

                error = null;

                if (isTooShort) {
                    error = 'Your employer name needs to be longer than 1 characters.';
                }

                if (isTooLong) {
                    error = 'Your employer name needs to be shorter than 101 characters.';
                }

                if (action.value.length === 0) {
                    error = "You'll need to enter an employer name.";
                }

                return setEmployerNameValid(error);
            case SET_CREDIT_CHECK_CONSENT_VALUE:
                error = action.value ? null : 'Sorry, we need your consent';
                return setCreditCheckConsentValid(error);
            default:
                return null;
        }
    })();

    if (!validationAction || validationIsEqual(validationAction, prevValidationAction)) {
        return next(action);
    }

    store.dispatch(validationAction);
    prevValidationAction = validationAction;
    return next(action);
};
